import {Component, Input, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {NgSelectComponent} from '@ng-select/ng-select';
import {CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray} from '@angular/cdk/drag-drop';
import {FormService} from '../../services/FormService';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-duplicate-block',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    NgSelectComponent,
    CdkDropList,
    CdkDrag,
    CdkDragHandle
  ],
  template: `
    <div class="form-row">
      <label>{{ Yii.t('app', 'Fields to Duplicate') }}
        <span class="text-danger">*</span>
      </label>
      <div>
        <ng-select
          style="width: 480px"
          [items]="fsvc.duplicate.FieldsThatCanBeDuplicated"
          [multiple]="true"
          [hideSelected]="true"
          bindLabel="tag"
          bindValue="key"
          appendTo="body"
          (change)="updateOrder()"
          [(ngModel)]="field_value">
        </ng-select>
      </div>
    </div>

    <!--Sorting -->
    @if (field.order && field.order.length > 0) {
      <div class="form-row">
        <label>{{ Yii.t('app', 'Order') }}</label>
        <div>
          <ul
            style="width:480px;margin: 0;padding:4px; gap: 4px; display: flex;list-style: none; border: solid 1px silver;border-radius: 4px;"
            cdkDropList
            cdkDropListOrientation="horizontal"
            class="list-unstyled"
            (cdkDropListDropped)="drop($event)">
            @for (item of field.order; track item) {
              <li
                cdkDrag
                style="cursor: move;"
                [id]="item">
                <div
                  cdkDragHandle
                  style="margin: 0;padding:4px 8px;border:dotted 1px silver;border-radius: 4px; background-color: #EEE">
                  {{ getOrderItemTitle(item) }}
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    }
  `
})
export class FieldDuplicateBlock implements OnInit {
  Yii = Yii;
  @Input() field: any;

  public field_value: number[] = []

  constructor(
    public fsvc: FormService,
  ) {
  }

  ngOnInit(): void {
    if (!this.field.order) {
      this.field.order = [];
    }
    if (!this.field.field_value) {
      this.field.field_value = [];
    }
    this.field_value = this.field.field_value.map(Number) ?? [];
  }

  updateOrder(): void {
    this.field.field_value = this.field_value.map(String) ?? [];
    const selectedIds = this.field.field_value?.map(String) ?? [];

    // Filter current order to keep only selected fields, preserving order
    const newOrder = this.field.order
      .map(String)
      .filter((id: string) => selectedIds.includes(id));

    // Add newly selected fields to the end of the order
    selectedIds.forEach((id: string) => {
      if (!newOrder.includes(id)) {
        newOrder.push(id);
      }
    });
    this.field.order = newOrder;
  }

  getOrderItemTitle(fieldId: any): string {
    const field = this.fsvc.form?.form_fields?.find((f: any) => f && String(f.field_id) === String(fieldId));
    return field ? (field.field_title || `Field-${parseInt(field.field_id, 10) + 1}`) : '';
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.field.order, event.previousIndex, event.currentIndex);
  }
}
